import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import type { Theme } from '@mui/material/styles';

export const CloseButton = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  width: theme?.novus.closeButtonSize,
  height: theme?.novus.closeButtonSize,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  '&:hover': {
    opacity: theme?.novus.closeButtonHoverOpacity,
  },
}));

export const CardGrid = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(min(380px, 100%), 1fr))',
  gap: theme?.novus.dialogContentGap,
}));

export const ErrorBanner = styled(Stack)<{ theme?: Theme }>(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme?.novus.errorBannerGap,
  padding: '8px 0',
  color: theme?.novus.errorRed,
}));
